import { render, staticRenderFns } from "./PopupResource.vue?vue&type=template&id=2feb36bd"
import script from "./PopupResource.vue?vue&type=script&lang=js"
export * from "./PopupResource.vue?vue&type=script&lang=js"
import style0 from "./PopupResource.vue?vue&type=style&index=0&id=2feb36bd&prod&lang=scss"
import style1 from "./PopupResource.vue?vue&type=style&index=1&id=2feb36bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports